export enum ReportType {
  Expected = 'Expected',
  Metric = 'Metric',
  Investigate = 'Investigate',
}

export interface ErrorLoggerInput {
  severity: ReportType;
  error: unknown;
  message?: string;
  requestId?: string;
}
